<template>
  <div></div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  mounted () {
    if (!this.$route.query.doctor_id) {
      this.fetchChat(this.$route.params.id, chat => {
        if (chat) {
          this.$router.push({ path: `/chats/${chat.id}` })
        } else {
          this.createInquiry(
            this.$route.params.id
          )
        }
      })
      // this.$router.push({ path: `/chats/${chat.id}` })
    } else {
      this.createInquiry(
        this.$route.params.id,
        this.$route.query.doctor_id
      )
    }
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setChat: 'chat/set'
    }),
    async createInquiry (clinic_id, doctor_id) {
      try {
        const params = { assignee_id: doctor_id, clinic_id: clinic_id }
        await this.axios.post('/api/clinic-inquiries', params)
        await this.fetchChat(clinic_id, chat => {
          this.$router.push({ path: `/chats/${chat.id}` })
        })
      } catch (err) {
        await this.fetchChat(clinic_id, chat => {
          this.$router.push({ path: `/chats/${chat.id}` })
        })
        // this.setError({
        //   message: err,
        //   type: 'danger'
        // })
      }
    },
    async fetchChat (id, callback) {
      try {
        const response = await this.axios.get(
          `/api/chat-spaces/by-clinic/${id}`
        )
        const chat = response.data.data
        if (chat) {
          this.setChat({
            chat_space: chat.chat_space,
            id: chat.id,
            last_message: chat.last_message,
            last_seen: chat.last_seen,
            type: chat.type
          })
        }
        callback(chat)
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
